<template>
    <div>
        <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>

        <span class="ix-text-small ix-text-secondary" v-if="!loading && stats.count == 0">Nous ne trouvons pas de données à vous afficher</span>

        <div class="row" v-if="!loading && stats.count != 0 && stats.count != null">
            <div class="col-sm-12 col-md-6 col-lg-2">
                 <custom-chart type="pie" :datasets="parityChart.datasets" :labels="parityChart.labels" :options="parityChart.options"></custom-chart>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-10">
                <div class="ix-table-box">
                    <table class="ix-table">
                        <tbody>
                            <tr>
                                <td>
                                    <span class="ix-gender-mr"><i class="far fa-mars"></i></span>
                                    Hommes
                                </td>
                                <td class="text-center">{{ stats.parity.men.count }}</td>
                                <td class="text-center">{{ stats.parity.men.percent }}%</td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="ix-gender-mrs"><i class="far fa-venus"></i></span>
                                    Femmes
                                </td>
                                <td class="text-center">{{ stats.parity.women.count }}</td>
                                <td class="text-center">{{ stats.parity.women.percent }}%</td>
                            </tr>
                            <tr>
                                <td>
                                    Non renseigné
                                </td>
                                <td class="text-center">{{ stats.parity.unspecified.count }}</td>
                                <td class="text-center">{{ stats.parity.unspecified.percent }}%</td>
                            </tr>
                            <tr>
                                <td class="ix-text-bold">Total</td>
                                <td class="text-center ix-text-bold ix-text-large">{{ stats.count }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row mt-3" v-if="stats.ages.min != null || stats.ages.max != null || stats.ages.average != null">
                    <div class="col-sm-12 col-md-12 col-lg-4" v-if="stats.ages.min != null">
                        <div class="ix-count-box">
                            <h2 class="ix-count-box-title">Salarié le plus jeune</h2>
                            <span class="ix-count-box-value">{{ stats.ages.min }} ans</span>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4" v-if="stats.ages.max != null">
                        <div class="ix-count-box">
                            <h2 class="ix-count-box-title">Salarié le plus âgé</h2>
                            <span class="ix-count-box-value">{{ stats.ages.max }} ans</span>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4" v-if="stats.ages.average != null">
                        <div class="ix-count-box">
                            <h2 class="ix-count-box-title">Moyenne d'âge</h2>
                            <span class="ix-count-box-value">{{ stats.ages.average }} ans</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomChart from '../CustomChart.vue';

    export default {
        props : {
            route : String,
        },
        components: {
            CustomChart
        },
        data() {
            return {
                loading: true,
                stats : null,

                parityChart: {
                    options: {
                        plugins: {
                            legend: {
                                display: false,
                            }
                        }
                    },
                    labels: ["Hommes", "Femmes", "Non renseigné"],
                    datasets: [
                        {
                            label: "Statistiques",
                            backgroundColor: ["#077FD4", "#CA03EA", "#F6F6F6"],
                            data: [],
                        }
                    ]
                }
            };
        },
        methods : {
            getData : async function(){
                fetch(this.route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.stats = data

                    this.parityChart.datasets[0].data.push(data.parity.men.count, data.parity.women.count, data.parity.unspecified.count)
                    
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
        },
        async mounted() {
            await this.getData();
        }
    }
</script>
